module.exports = __webpack_public_path__ + "images/station.63b14493277456d9344c173ef5813e2d.svg";